module.exports = __webpack_public_path__ + "img/box3.70dff1d1.png";